/* eslint-disable import/prefer-default-export */
import { firebase } from './firebase'
import { getCurrentRoute } from '../navigators/NavigationRefHelpers'

const trackEvent = (event, screen) => {
  const trackId = event.replace(/[^a-zA-Z\d_]/g, '_')
  const screenToTrack = getCurrentRoute() || screen || 'notAvailable'
//  console.log(`event: ${event} and screenToTrack: ${screenToTrack}`)
  try {
    const parameters = screenToTrack ? {
      screen_name: screenToTrack,
      screen_class: `${screenToTrack}_class`,
    } : undefined
    // console.log('loggingEvent: ', trackId)
    firebase.analytics()
      .logEvent(trackId, parameters)
  } catch (x) {
    // console.log('Error in TrackEvent: ', x)
  }
}

const setScreen = (screen) => {
  firebase.analytics()
    .logScreenView({
      screen_name: screen,
      screen_class: screen,
    })
}

export { trackEvent, setScreen }
